
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[newsTypeUrl]/[slug]",
      function () {
        return require("private-next-pages/news/[newsTypeUrl]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/[newsTypeUrl]/[slug]"])
      });
    }
  